import { AppStoreBadgeComponent } from '@components/illustrations/AppStoreBadge';
import { APPSTORE_BUTTONS_ADJUST_LINK_SIGNUP_FLOW } from '@utils/constants';
import { twMerge } from 'tailwind-merge';

export function AppStoreButton({ className }: { className?: string }) {
  return (
    <a
      className={twMerge('h-12', className)}
      href={APPSTORE_BUTTONS_ADJUST_LINK_SIGNUP_FLOW}
      target="_blank"
      rel="noreferrer"
    >
      <AppStoreBadgeComponent className="h-full"></AppStoreBadgeComponent>
    </a>
  );
}
